import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaforpunetoshirdionrent() {



    const cardData =
    {
        keyword: 'Urbania for Pune to Shirdi On Rent',
        heading: 'Urbania on rent in pune: Urbania for Pune to Shirdi On Rent',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Urbania for Pune to Shirdi On Rent services for families, pilgrims, corporate groups, and tourist travelers planning trips to Shirdi. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for religious tours, weekend getaways, corporate outings, and group travel from Pune to Shirdi. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and hassle-free journey. Supported by 24/7 booking assistance, transparent pricing, and dependable service, Urbania On Rent in Pune stands out as the trusted choice for Urbania hire from Pune to Shirdi.',

        top: 'Top Places to Visit in shirdi with Urbania on rent in pune',


        "topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "The Shirdi Sai Baba Temple is the most revered spiritual destination in Shirdi, attracting millions of devotees from across India and the world. The temple complex includes the Samadhi Mandir, where Sai Baba’s mortal remains are interred, along with other sacred spots like Dwarkamai and Chavadi. Devotees come here to offer prayers, participate in aarti ceremonies, and experience the peaceful ambiance, seeking blessings and spiritual solace."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is the mosque where Sai Baba spent a significant portion of his life. The sacred structure houses Baba’s sacred belongings, including his sacred oil lamps and belongings, and is the center of daily rituals and prayers. Visitors experience the spiritual atmosphere, reflecting on Baba’s teachings of faith, devotion, and service."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is a small structure where Sai Baba used to spend alternate nights. It is an important part of the temple circuit and hosts rituals and prayers that recreate the historical practices of Sai Baba. Devotees often perform parikrama and spend quiet moments in meditation here."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is an interactive museum and cultural center that depicts the life and teachings of Sai Baba through sculptures, dioramas, and multimedia displays. Visitors can learn about the spiritual, social, and charitable aspects of Baba’s life, making it both educational and inspiring."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park is a popular recreational destination near Shirdi, offering slides, wave pools, and adventure activities suitable for families and tourists. The park provides a fun-filled day alongside spiritual visits, making Shirdi a balanced destination for devotion and leisure."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is a local spiritual site dedicated to Lord Khandoba, revered in Maharashtra. Visitors often include this temple in their Shirdi tour, experiencing local traditions and architecture along with spiritual reflection."
  },
  {
    "title": "Grampanchayat Garden",
    "description": "The Grampanchayat Garden is a well-maintained public park near the temple complex where visitors can relax, enjoy greenery, and spend time with family after their spiritual visit. The calm environment provides a peaceful break from the bustling temple area."
  },
  {
    "title": "Shirdi Sai Baba Museum",
    "description": "The Shirdi Sai Baba Museum provides insights into the life, teachings, and miracles of Sai Baba. Exhibits include rare photographs, letters, and artifacts associated with Baba’s life. It is both educational and spiritually enriching for devotees and tourists."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a garden located near the Shirdi temple complex, planted by Sai Baba himself. It is a serene and shaded area with fountains, trees, and pathways where devotees can meditate, relax, or take a quiet stroll amidst greenery."
  },
  {
    "title": "Sainagar Shirdi Railway Station",
    "description": "Sainagar Shirdi Railway Station is a key transportation hub connecting Shirdi to major cities in India. The station provides easy access for pilgrims traveling to the town, and its well-planned facilities ensure a smooth and convenient journey for visitors."
  }
],



"services": [
    {
      "name": "Urbania for Pune to Shirdi on Rent",
      "description": "Urbania for Pune to Shirdi on Rent offers comfortable and reliable Urbania vehicles for one-way or round-trip journeys to Shirdi. Ideal for families, groups, and pilgrims, the service ensures spacious seating, well-maintained interiors, and professional chauffeurs, providing a safe and stress-free travel experience for devotional trips or leisure visits."
    },
    {
      "name": "Pune to Shirdi Urbania Hire",
      "description": "Pune to Shirdi Urbania Hire provides convenient and cost-effective Urbania rentals for travel between Pune and Shirdi. Perfect for group outings, family trips, and corporate travel, these vehicles come with experienced drivers, ample luggage space, and a focus on comfort, reliability, and timely arrivals."
    },
    {
      "name": "Urbania Bus Rental Pune to Shirdi",
      "description": "Urbania Bus Rental Pune to Shirdi delivers spacious and well-maintained buses for group travel, tours, and pilgrimages. Designed for comfort and convenience, these buses feature ample seating, safety features, and professional chauffeurs to ensure smooth, stress-free journeys to Shirdi from Pune."
    },
    {
      "name": "Urbania AC Bus Pune to Shirdi",
      "description": "Urbania AC Bus Pune to Shirdi provides fully air-conditioned vehicles for a comfortable long-distance journey. Perfect for group tours, family trips, and corporate outings, the buses ensure a pleasant ride with climate control, spacious interiors, professional drivers, and reliable service from Pune to Shirdi."
    },
    {
      "name": "Pune Shirdi Urbania One Way Hire",
      "description": "Pune Shirdi Urbania One Way Hire offers flexible one-way travel options for individuals, families, or corporate teams traveling to Shirdi. Vehicles are well-maintained, comfortable, and driven by trained chauffeurs, providing a convenient and hassle-free travel experience tailored to your schedule."
    },
    {
      "name": "Pune Shirdi Urbania Round Trip Hire",
      "description": "Pune Shirdi Urbania Round Trip Hire delivers convenient and comfortable round-trip travel solutions for pilgrims, families, and groups. With punctual service, spacious seating, and professional drivers, travelers can enjoy a stress-free journey to Shirdi and back without worrying about logistics or delays."
    },
    {
      "name": "Corporate Urbania Pune to Shirdi",
      "description": "Corporate Urbania Pune to Shirdi provides professional transportation solutions for office trips, conferences, and corporate events to Shirdi. Vehicles are equipped for executive comfort, with trained chauffeurs, timely service, and clean interiors, ensuring a seamless travel experience for corporate teams."
    },
    {
      "name": "Family Tour Urbania Pune to Shirdi",
      "description": "Family Tour Urbania Pune to Shirdi offers safe, comfortable, and spacious Urbania vehicles for family outings and group pilgrimages. With courteous drivers, ample luggage space, and well-maintained interiors, this service ensures a relaxing and enjoyable journey from Pune to Shirdi."
    },
    {
      "name": "Luxury Urbania Pune to Shirdi",
      "description": "Luxury Urbania Pune to Shirdi provides high-end air-conditioned vehicles with plush interiors and superior ride quality for VIPs, executives, and travelers seeking premium comfort. Professional chauffeurs, spacious seating, and a smooth travel experience make it perfect for luxurious pilgrimages and leisure trips."
    },
    {
      "name": "Affordable Urbania Pune to Shirdi",
      "description": "Affordable Urbania Pune to Shirdi offers cost-effective transportation options for pilgrims, families, and budget-conscious travelers. With well-maintained vehicles, safe driving, and courteous chauffeurs, it ensures a comfortable journey without compromising on service quality or reliability."
    },
    {
      "name": "Chauffeur Driven Urbania Pune to Shirdi",
      "description": "Chauffeur Driven Urbania Pune to Shirdi provides stress-free travel with trained and verified drivers. Vehicles are reliable, spacious, and suitable for long-distance travel, ensuring that families, groups, and corporate teams can focus on their journey without worrying about navigation or safety."
    },
    {
      "name": "Pune Shirdi Urbania Travel Service",
      "description": "Pune Shirdi Urbania Travel Service offers end-to-end travel solutions for journeys between Pune and Shirdi. From comfortable vehicles and experienced chauffeurs to timely pickups and luggage management, the service ensures a seamless, convenient, and enjoyable travel experience for all types of travelers."
    },
    {
      "name": "Best Urbania Hire Pune to Shirdi",
      "description": "Best Urbania Hire Pune to Shirdi provides top-rated vehicles and exceptional service for travel between Pune and Shirdi. Focused on comfort, safety, and reliability, this service is ideal for families, corporate teams, and groups looking for a hassle-free and high-quality travel experience."
    },
    {
      "name": "Pune to Shirdi Urbania Booking",
      "description": "Pune to Shirdi Urbania Booking enables easy and convenient reservation of Urbania vehicles for one-way or round-trip journeys. Travelers can choose from various vehicle types, ensuring comfort, punctuality, and professional chauffeur services for a smooth travel experience."
    },
    {
      "name": "Urbania for Pilgrimage Tour Pune",
      "description": "Urbania for Pilgrimage Tour Pune specializes in providing vehicles for devotional trips and religious tours. With spacious seating, safe driving, and reliable service, travelers can enjoy a stress-free journey to Shirdi and other nearby pilgrimage destinations while focusing on their spiritual experience."
    }
  ],
  "tableData": [
    ["Urbania for Pune to Shirdi on Rent", "Pune to Shirdi Urbania Hire"],
    ["Urbania Bus Rental Pune to Shirdi", "Urbania AC Bus Pune to Shirdi"],
    ["Pune Shirdi Urbania One Way Hire", "Pune Shirdi Urbania Round Trip Hire"],
    ["Corporate Urbania Pune to Shirdi", "Family Tour Urbania Pune to Shirdi"],
    ["Luxury Urbania Pune to Shirdi", "Affordable Urbania Pune to Shirdi"],
    ["Chauffeur Driven Urbania Pune to Shirdi", "Pune Shirdi Urbania Travel Service"],
    ["Best Urbania Hire Pune to Shirdi", "Pune to Shirdi Urbania Booking"],
    ["Urbania for Pilgrimage Tour Pune", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania for Pune to Shirdi On Rent",
        "WhyChoosedescription": "Urbania for Pune to Shirdi On Rent is ideal for comfortable and spacious group travel, perfect for family trips, pilgrimages, corporate travel, and outstation journeys."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania for Pune to Shirdi On Rent offers well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring a smooth and hassle-free ride."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Urbania for Pune to Shirdi On Rent comes with skilled drivers familiar with the Pune-Shirdi route and highways, guaranteeing safety, punctuality, and a stress-free journey."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Urbania for Pune to Shirdi On Rent for competitive rates with no hidden charges, making outstation group travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania for Pune to Shirdi On Rent provides round-the-clock assistance for bookings, inquiries, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania for Pune to Shirdi On Rent is available for one-way trips, round trips, corporate travel, wedding transportation, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania vehicles for Pune to Shirdi trips are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania for Pune to Shirdi On Rent guarantees timely pickups and dependable service, ensuring stress-free and smooth travel."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania for Pune to Shirdi On Rent available for local travel as well?',
        answer: 'Yes, Urbania for Pune to Shirdi On Rent can also be booked for local travel within Pune or nearby areas, offering a comfortable and spacious ride.',
    },
    {
        question: 'How can I book Urbania for Pune to Shirdi On Rent?',
        answer: 'You can book Urbania for Pune to Shirdi On Rent via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania for Pune to Shirdi On Rent for group travel?',
        answer: 'Urbania for Pune to Shirdi On Rent provides ample seating, luggage space, and a smooth ride, making it ideal for family, corporate, and group travel.',
    },
    {
        question: 'Is Urbania for Pune to Shirdi On Rent suitable for corporate and event travel?',
        answer: 'Yes, it is perfect for corporate trips, airport transfers, weddings, events, and one-way or round-trip travel to Shirdi.',
    },
    {
        question: 'Are drivers experienced with Urbania for Pune to Shirdi On Rent?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles to ensure safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania for Pune to Shirdi On Rent?',
        answer: 'Absolutely. Urbania for Pune to Shirdi On Rent allows flexible pickup and drop-off across Pune and Shirdi.',
    },
    {
        question: 'Is Urbania for Pune to Shirdi On Rent available 24x7?',
        answer: 'Yes, Urbania for Pune to Shirdi On Rent operates 24x7 to accommodate travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania for Pune to Shirdi On Rent?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for every trip.',
    },
    {
        question: 'What payment options are available for Urbania for Pune to Shirdi On Rent?',
        answer: 'Urbania for Pune to Shirdi On Rent accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ravi Kulkarni',
        feedback: 'We booked Urbania for Pune to Shirdi On Rent for a pilgrimage. The vehicle was spacious, comfortable, and reliable. Excellent service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anusha Patil',
        feedback: 'Urbania for Pune to Shirdi On Rent provided seamless service for our family trip. The driver was professional and punctual. Highly recommended!',
        rating: 5,
    },
];

























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania for Pune to Shirdi On Rent",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-pune-to-shirdi.jpg",
  "description": "Urbania for Pune to Shirdi On Rent offers reliable bus rental services for one-way and round-trip travel. AC and non-AC Urbania buses are available for family tours, corporate trips, pilgrimage tours, and luxury travel. Chauffeur-driven Urbania buses ensure comfortable and safe journeys from Pune to Shirdi at affordable rates.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1100",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-pune-to-shirdi-on-rent"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania for Pune to Shirdi On Rent | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania for Pune to Shirdi On Rent for one-way or round-trip travel. AC and non-AC Urbania buses for family tours, corporate trips, pilgrimage tours, and luxury travel. Chauffeur-driven service for comfortable journeys."
  />

  <meta
    name="keywords"
    content="Urbania for Pune to Shirdi on Rent, Pune to Shirdi Urbania Hire, Urbania Bus Rental Pune to Shirdi, Urbania AC Bus Pune to Shirdi, Pune Shirdi Urbania One Way Hire, Pune Shirdi Urbania Round Trip Hire, Corporate Urbania Pune to Shirdi, Family Tour Urbania Pune to Shirdi, Luxury Urbania Pune to Shirdi, Affordable Urbania Pune to Shirdi, Chauffeur Driven Urbania Pune to Shirdi, Pune Shirdi Urbania Travel Service, Best Urbania Hire Pune to Shirdi, Pune to Shirdi Urbania Booking, Urbania for Pilgrimage Tour Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/31.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaforpunetoshirdionrent;